import type { App } from 'vue'
import type {} from '../bootstrap'
import PageHead from './components/PageHead.vue'
import { type PageHead as PageHeadValue, usePageHeadStore } from './store'

export type { PageHead } from './store'
export { usePageHeadStore } from './store'

declare module 'vue' {
  interface GlobalComponents {
    PageHead: typeof PageHead
  }
}

export const usePageHead = (next: PageHeadValue) => usePageHeadStore().patch(next)

export const createHead = () => ({
  install: (app: App) => {
    app.component('PageHead', PageHead)

    const router = app.getRouter()
    app.runWithContext(() => {
      const store = usePageHeadStore()
      router.afterEach(to => store.replace(to.meta.head ?? {}))
    })
  }
})
